export default [
  {
    text: 'В аренде',
    value: 'rent',
  },
  {
    text: 'В собственности',
    value: 'owned',
  },
];
